import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Translation } from '@/hoslog-intl';

export const Route = createFileRoute('/(app)/points-management/points-transfer')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <Translation id="pointManagement.sidebar.menu.pointsTransfer" />,
      title: <Translation id="pointManagement.sidebar.menu.pointsTransfer" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
